import { useEffect, useState } from "react";
import { NavLink } from "react-router-dom";
import { Twirl as Hamburger } from "hamburger-react";
import ThemeToggle from "../ThemeToggle";
import BandwidthToggle from "../BandwidthToggle";
import "./Navbar.css";

const NAV_LINKS = [
  { path: "/", text: "Home" },
  { path: "/About", text: "About Me" },
  { path: "/Services", text: "My services" },
  { path: "/Projects", text: "Projects" },
  { path: "/Contact", text: "Contact" },
];

function Navbar() {
  const [isOpen, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header className={`navbar ${scrolled ? "is-scrolled" : ""}`}>
      <div className="navbar__inner container">
        <NavLink to="/" className="navbar__brand" onClick={() => setOpen(false)}>
          <span className="navbar__brand-mark">AO</span>
          <span className="navbar__brand-text">Daniel Oshinubi</span>
        </NavLink>

        <nav className={`navbar__menu ${isOpen ? "is-open" : ""}`}>
          <ul className="navbar__list">
            {NAV_LINKS.map((link) => (
              <li key={link.path}>
                <NavLink
                  to={link.path}
                  end={link.path === "/"}
                  className={({ isActive }) =>
                    `navbar__link ${isActive ? "is-active" : ""}`
                  }
                  onClick={() => setOpen(false)}
                >
                  {link.text}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        <div className="navbar__actions">
          <BandwidthToggle />
          <ThemeToggle />
          <div className="navbar__hamburger">
            <Hamburger
              toggled={isOpen}
              toggle={setOpen}
              size={22}
              label="Toggle menu"
            />
          </div>
        </div>
      </div>
    </header>
  );
}

export default Navbar;
